import axios from "axios";

async function checkEcvServicesStatus(check){
  console.log(`${check.title} Check Started`);

  const queryParams = new URLSearchParams(window.location.search);
  const healthCheckToken = queryParams.get("healthCheckToken");
    
  let reply = { isPassed: false, details: "Not Working!" };

  let response;
  let details = {};
  try {
    if(healthCheckToken){
      response = await axios.get("/health?" + new URLSearchParams({ token: healthCheckToken }).toString());
    }
    else {
      response = await axios.get("/health");
    }
  }
  catch(error){
    details["Error"] = error.message;
    response = error?.response;
  }
  
  if(response?.data){
    const data = response.data;
  
    if(data && typeof data?.status != "string"){
      details["Failed"] = `Not working properly, status is not a string, ${JSON.stringify(response.data)}`;
    }
  
    if(data?.status?.toLowerCase() == "healthy"){
      reply.isPassed = true;
      details["Success"] = "Working properly.";
    }
    else {
      for(let service in data.results){
        if(data.results[service].status?.toLowerCase() != "healthy"){
          details[service] = `${data.results[service].status}, ${data.results[service].description}${data.results?.[service]?.data ? ", "+JSON.stringify(data.results?.[service]?.data): ""}.`;
        }
      }
    }
  }

  // ecv-admin-ldap: Degraded, Server Down. Result: 81. Method: ldap_connect: {}.
  reply.details = `\n${Object.keys(details).map(service => `\t- ${service}: ${details[service]}`).join("\n")}`;
  reply.details = `${check.title}: ${reply.details}`;
  return reply;
}

export default checkEcvServicesStatus;